import { render, staticRenderFns } from "./ProductBoards.vue?vue&type=template&id=531c73fc&scoped=true&"
import script from "./ProductBoards.vue?vue&type=script&lang=js&"
export * from "./ProductBoards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c73fc",
  null
  
)

export default component.exports